import resourcesToBackend from "../external/_pnpm/i18next-resources-to-backend@1.2.1/external/i18next-resources-to-backend/dist/esm/index.js";
const pseudoLocalize = (json) => {
  const PSEUDO_LOCALIZE_CHAR_MAP = {
    a: "ȧȧ",
    b: "ƀ",
    c: "ƈ",
    d: "ḓ",
    e: "ḗḗ",
    f: "ƒ",
    g: "ĝ",
    h: "ħ",
    i: "ī",
    j: "ĵ",
    k: "ḳ",
    l: "ŀ",
    m: "ḿ",
    n: "ƞ",
    o: "ǿǿ",
    p: "ƥ",
    q: "ɋ",
    r: "ř",
    s: "ş",
    t: "ŧ",
    u: "ŭ",
    v: "ṽ",
    w: "ŵ",
    x: "ẋ",
    y: "ẏ",
    z: "ẓ",
    A: "ȦȦ",
    B: "Ƀ",
    C: "Ċ",
    D: "Ḓ",
    E: "ḖḖ",
    F: "Ƒ",
    G: "Ĝ",
    H: "Ħ",
    I: "Ī",
    J: "Ĵ",
    K: "Ḳ",
    L: "Ŀ",
    M: "Ṁ",
    N: "Ń",
    O: "ØØ",
    P: "Ᵽ",
    Q: "Ɋ",
    R: "Ŗ",
    S: "Ṡ",
    T: "Ŧ",
    U: "Ů",
    V: "Ṿ",
    W: "Ŵ",
    X: "Ẍ",
    Y: "Ŷ",
    Z: "Ż"
  };
  const pseudoLocalizeString = (str) => {
    let result = "";
    for (let i = 0; i < str.length; i += 1) {
      const char = str[i];
      result += PSEUDO_LOCALIZE_CHAR_MAP[char] || char;
    }
    return result;
  };
  Object.keys(json).forEach((key) => {
    if (typeof json[key] === "string") {
      const parts = json[key].match(
        // https://regex101.com/r/XZEJYe/1
        /\{\{[^}]*\}\}|\{[^}]*\}|<[^>]*>|\||[^{}<>|]+/g
      );
      if (!parts?.length) {
        return;
      }
      for (let index = 0; index < parts.length; index += 1) {
        const part = parts[index];
        if (part && !part.startsWith("<") && // Skip HTML tags
        !part.startsWith("|") && // Skip pipes
        part.match(/^[^{].*[^}]$/)) {
          parts[index] = pseudoLocalizeString(part);
        }
      }
      json[key] = parts.join("");
    } else if (typeof json[key] === "object" && json[key] !== null) {
      pseudoLocalize(json[key]);
    }
  });
  return json;
};
globalThis.__serviceI18NResources ??= {};
function setResource(lang, resource) {
  try {
    globalThis.__serviceI18NResources["shared-ui-error-boundary"] = globalThis.__serviceI18NResources["shared-ui-error-boundary"] || {};
    globalThis.__serviceI18NResources["shared-ui-error-boundary"][lang] = { translation: resource };
  } catch (error) {
    console.error("i18n - Failed to set resource:", error);
  }
}
const localeModules = /* @__PURE__ */ Object.assign({ "/src/generated-locales/ca-ES.json": () => import("../generated-locales/ca-ES.json.js"), "/src/generated-locales/en-AU.json": () => import("../generated-locales/en-AU.json.js"), "/src/generated-locales/en-CA.json": () => import("../generated-locales/en-CA.json.js"), "/src/generated-locales/en-GB.json": () => import("../generated-locales/en-GB.json.js"), "/src/generated-locales/en-IE.json": () => import("../generated-locales/en-IE.json.js"), "/src/generated-locales/en.json": () => import("../generated-locales/en.json.js"), "/src/generated-locales/es-ES.json": () => import("../generated-locales/es-ES.json.js"), "/src/generated-locales/es-MX.json": () => import("../generated-locales/es-MX.json.js"), "/src/generated-locales/es.json": () => import("../generated-locales/es.json.js"), "/src/generated-locales/fr-CA.json": () => import("../generated-locales/fr-CA.json.js"), "/src/generated-locales/fr-FR.json": () => import("../generated-locales/fr-FR.json.js"), "/src/generated-locales/ja.json": () => import("../generated-locales/ja.json.js") });
const importLocale = async (lang) => {
  try {
    if (lang === "pseudo") {
      const importedLocale = await localeModules["/src/generated-locales/en.json"]();
      setResource("pseudo", importedLocale);
      return pseudoLocalize(importedLocale);
    }
    const key = `/src/generated-locales/${lang}.json`;
    const importer = localeModules[key];
    if (importer) {
      const importedLocale = await importer();
      setResource(lang, importedLocale);
      return importedLocale;
    }
  } catch (error) {
    console.error("i18n - Failed to import locale:", error);
  }
};
const serviceI18NResourcesToBackendPlugin = () => resourcesToBackend(importLocale);
export {
  serviceI18NResourcesToBackendPlugin
};
//# sourceMappingURL=resources.js.map
